export default __webpack_public_path__ + "assets/ogg/8eefa7ea96bf1232c2d1cb01c2066aa5.ogg";